module.exports = __webpack_public_path__ + "static/media/heroBanner1.01abf9aa.webp";